module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('home-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04c6c946!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 135
// module chunks = 1